import React from 'react';
import PropTypes from 'prop-types';
import { get, isString } from 'lodash';
import { compose, withPropsOnChange, withHandlers } from 'recompose';
import DropdownIcon from 'components/svg/Dropdown';
import DropdownOption from './DropdownOption';

import './Dropdown.scss';

export const enhance = compose(
	withHandlers({
		onSelectOption:
			({ onSelect, selected }) =>
			(option) =>
				onSelect(selected !== option ? option : null),
	}),
	// Converts Array of Strings to Objects
	withPropsOnChange(['options'], ({ options }) => ({
		options: options.map((option) =>
			isString(option) ? { label: option, value: option } : option,
		),
	})),
	// Finds the active label
	withPropsOnChange(['selected'], ({ selected, options }) => ({
		selectedLabel: get(
			options.find((option) => selected === option.value),
			'label',
			null,
		),
	})),
);

export function Dropdown({
	defaultLabel,
	label,
	onMouseEnter,
	onSelectOption,
	options,
	selected,
	selectedLabel,
}) {
	return (
		<div
			className="ss-dropdown"
			onMouseEnter={onMouseEnter}
		>
			<div className="label">
				{label} <DropdownIcon />
			</div>
			<div className="selected">{selectedLabel || defaultLabel}</div>
			<ul className="options">
				<li className="dropdown-item">
					<DropdownOption
						value={null}
						label="All"
						selected={!selected}
						onSelect={onSelectOption}
					/>
				</li>
				{options.map((option) => (
					<li
						key={option.value}
						className="dropdown-item"
					>
						<DropdownOption
							value={option.value}
							label={option.label}
							selected={selected === option.value}
							onSelect={onSelectOption}
						/>
					</li>
				))}
			</ul>
		</div>
	);
}

Dropdown.propTypes = {
	label: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
		}).isRequired,
	).isRequired,
	selected: PropTypes.string,
	selectedLabel: PropTypes.string,
	onMouseEnter: PropTypes.func,
	onSelectOption: PropTypes.func.isRequired,
	defaultLabel: PropTypes.string,
};

Dropdown.defaultProps = {
	defaultLabel: 'Make Selection',
};

export default enhance(Dropdown);
